import React from 'react'
import shortenString from './helpers/shortenString'

export default function Front(props) {
	return (

		<div className="front row d-flex justify-content-center flex-wrap pr-0">
			<div className="coverArt col-3 col-sm-2"><img alt={props.activeEpisode.title} style={{minWidth: '60px'}} src={props.activeEpisode.itunes.image}/></div>
			
			<div className="infos col-8 col-sm-6">
				<div className="episode_title">{ shortenString(props.activeEpisode.title) }</div>
				<a className='pointer text-white' target='_blank' href={ props.podcast.link } rel="noopener noreferrer">
					<div className="podcast_title">{ props.podcast.title }</div>
				</a>
				{/* shortenString(props.podcast.description) */}
				
				<div className="tags">
				{
					props.podcast.itunes.categories.map(item => {
						return <span key={item}>{ item }</span>
					})	
				}
				</div>
			</div>

			<div className='side col-1 col-sm-4 p-0'>
				<a className='d-none d-sm-block' href={'https://studio.hubhopper.com'} target="_blank" rel="noopener noreferrer">
					<div className='listenonhh p-1'>
					<span className='text-white' style={{fontSize:'0.8em'}}>Powered by</span><br/> <span style={{fontFamily:'Kimberley'}}>hubhopper</span> Studio
					</div>
				</a><br/>
				<a className='pointer p-1 text-white' onClick={props.toggleMenu} style={{zIndex: '11'}}>
					{props.showMenu ? <i className="fas fa-times"></i> : <i className="fas fa-info-circle"></i> } 
				</a>
			</div>
			
		</div>

	);
}